<template>
  <div class="mainapp">
    <div class="canvascontainer">
      <PlayCanvas
        @appCreated="appCreated"
        @appProgress="appProgress"
        ref="pcapp"
      />
    </div>
    <div class="slogan">
      <div class="title">CREATIVE TECHNOLOGY STUDIO</div> 
    </div>
  </div>
</template>

<script>
import PlayCanvas from "./components/Playcanvas.vue";

export default {
  name: "App",
  components: {
    PlayCanvas
  },
  methods: {
    appCreated(app) {
      this.app = app;
      //add app listeners here
    },
    appProgress(perc) {
      // console.log("loading progress "+perc);
      this.appPercent = perc;
      if (perc == 1) this.appLoaded = true;
    },
    doLoadApp() {
        this.$refs.pcapp.initApp();
    },
  },
  mounted() {
    if (!this.app) this.doLoadApp();
  },
};
</script>

<style>
.mainapp{
  background-color: transparent;
}
.canvascontainer {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  z-index: 2;
  background-color: transparent;
}
.slogan{
  color: var(--primary-color-1);
  position: absolute;
  width: 100vw;
  height: 85vh;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 3;
  user-select: none;
  pointer-events: none;
}
</style>
